import {
    Breadcrumb, Button, Checkbox, Input, Table,
} from 'appkit-react';
import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function Intake({
    breadcrumbItems, tableData, columns,
    showSuccessAlert, setShowSuccessAlert, showErrorAlert, setShowErrorAlert, successMsg, errorMsg,
    filterString, setFilterString, active, setActive, inactive, setInactive,
}) {
    const history = useHistory();

    return (
        <div>
            <div className="true-comply-tenant_management_layout">
                <div className="true-comply-tenant_management_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    {showSuccessAlert && (
                        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible="true">{successMsg}</Alert>
                    )}
                    {showErrorAlert && (
                        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible="true">{errorMsg}</Alert>
                    )}
                    <Row>
                        <Col md={5}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.push('/')} role="presentation" />
                                Registration Intake
                            </div>
                        </Col>
                    </Row>

                    <Row className="true-comply-tenant_management_padding">
                        <Col md={2} style={{ paddingRight: 0 }} className="true-comply-user_management_filter_column">
                            <div className="true-comply-user_management-search_option">
                                <div>
                                    <div className="form-label">SEARCH</div>
                                    <div className="secondary-input-container a-apply-theme-background-gray-level-2">
                                        <Input
                                            inputBoxSize="sm"
                                            placeholder="Search here"
                                            value={filterString}
                                            onChange={e => setFilterString(e)}
                                        />
                                    </div>
                                </div>
                                <div className="form-label">STATUS</div>
                                <Row>
                                    <Col>
                                        <Checkbox
                                            checked={active}
                                            onChange={() => setActive(!active)}
                                        >
                                            <span className="checkbox-label">Pending</span>
                                        </Checkbox>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                                    <Col>
                                        <Checkbox
                                            checked={inactive}
                                            onChange={() => setInactive(!inactive)}
                                        >
                                            <span className="checkbox-label">Invited</span>
                                        </Checkbox>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={9} className="true-comply-tenant_management_padding true-comply-tenant_management-table_column">
                            <div style={{ marginTop: '0.5rem' }}>
                                <Table
                                    data={tableData}
                                    columns={columns}
                                    defaultPageSize={10}
                                    sortable
                                    size="lg"
                                    resizable
                                    className="-striped -highlight ReactTable rt-expander"
                                    noDataText="No Tenants Found!!!"
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
